import { AppLayout } from '@/components/app-layout';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { AnalyticsContainer } from '@/containers/analytics/analytics-container.component';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/reports')({
  component: ReportsPage,
});

function ReportsPage() {
  return (
    <>
      <Head heading='Reports' />
      <AuthCheck>
        <AppLayout variant='full-bleed'>
          {/* Open to everyone — no route-level feature gate. Per-tab gating
              lives in AnalyticsContainer: the Overview tab is visible to all
              tiers; the remaining tabs are Scale/Enterprise only. AppSumo-only
              orgs resolve to tier_category 'free', so all AppSumo tiers see
              Overview only. */}
          <AnalyticsContainer />
        </AppLayout>
      </AuthCheck>
    </>
  );
}
